import { __styles, mergeClasses, tokens } from '@fluentui/react-components';
export const sensitivityIconClassNames = {
  root: 'fai-SensitivityIcon',
  foregroundIcon: 'fai-SensitivityIcon__foregroundIcon',
  backgroundIcon: 'fai-SensitivityIcon__backgroundIcon'
};
/**
 * Styles for the root slot
 */
const useStyles = __styles({
  root: {},
  backgroundIcon: {
    qhf8xq: "f1euv43f",
    Bj3rh1h: "f11zp4z2"
  },
  foregroundIcon: {
    qhf8xq: "f10pi13n",
    Bj3rh1h: "f19g0ac",
    sj55zd: "f19n0e5"
  }
}, {
  d: [".f1euv43f{position:absolute;}", ".f11zp4z2{z-index:0;}", ".f10pi13n{position:relative;}", ".f19g0ac{z-index:1;}", ".f19n0e5{color:var(--colorNeutralForeground1);}"]
});
/**
 * Apply styling to the SensitivityIcon slots based on the state
 */
export const useSensitivityIconStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(sensitivityIconClassNames.root, styles.root, state.root.className);
  if (state.foregroundIcon) {
    state.foregroundIcon.className = mergeClasses(sensitivityIconClassNames.foregroundIcon, styles.foregroundIcon, state.foregroundIcon.className);
  }
  if (state.backgroundIcon) {
    state.backgroundIcon.className = mergeClasses(sensitivityIconClassNames.backgroundIcon, styles.backgroundIcon, state.backgroundIcon.className);
  }
  return state;
};
//# sourceMappingURL=useSensitivityIconStyles.js.map